export class DateFormatValueConverter {
    toView(value) {
        if (value === undefined || value == null) {
            return '';
        }
        // value is in sql format: 2017-09-12
        return value.substring(8, 10) + "." + value.substring(5, 7) + "." + value.substring(0, 4);
    }
}